export const COMPANY_NOT_FOUND_ERROR = 'Company not found';
